"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_query_1 = require("react-query");
var utilities_1 = require("../../../utilities");
var constants_1 = require("../../../constants");
var transactions_service_1 = __importDefault(require("../../../services/transactions/transactions.service"));
var react_error_boundary_1 = require("react-error-boundary");
function useGetTransactionsByClientCardId(clientCardId) {
    var showBoundary = (0, react_error_boundary_1.useErrorBoundary)().showBoundary;
    return (0, react_query_1.useQuery)([constants_1.GET_TRANSACTIONS_BY_CLIENT_CARD_ID, clientCardId], function () { return transactions_service_1.default.getTransactionsByClientCardId(clientCardId); }, {
        staleTime: 1000 * 60 * 30,
        onError: function (error) {
            (0, utilities_1.handleError)(error);
            showBoundary(error);
        }
    });
}
exports.default = useGetTransactionsByClientCardId;
